import { useState } from "react";
import dayjs from "dayjs";
import { atualizarReservaService } from "../../../services/atualizarReservaService";

export const useConfirmarReserva = (
  reservaId: number | null,
  dataConfirmacao: any
) => {
  const [isLoading, setIsLoading] = useState(false);
  const [warning, setWarning] = useState<string | null>(null);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const [successMessage, setSuccessMessage] = useState<string | null>(null);

  const atualizar = async () => {
    setWarning(null); // Resetando warning antes de tentar novamente
    setErrorMessage(null); // Resetando mensagem de erro antes de tentar novamente
    setIsLoading(true);

    const dataReserva = {
      statusReserva: "AGUARDANDO_PAGAMENTO_PROPRIETARIO",
      dataConfirmacaoReserva: dataConfirmacao
        ? dayjs(dataConfirmacao.dataConfirmacao).format("YYYY-MM-DD HH:mm:ss")
        : null,
      observacao: dataConfirmacao.observacao,
    };

    try {
      // Condicional para verificar se existe observação, ou outro dado importante
      if (!dataConfirmacao?.observacao?.trim()) {
        setWarning("Por favor, insira uma observação.");
        setIsLoading(false);
        return; // Impede a execução caso não tenha uma observação
      }
      // Se o serviço de atualização falhar, pode atualizar o erro
      // Caso o `atualizarReserva` retorne um valor falso, exibe um erro
      const atualizarReserva = await atualizarReservaService(
        reservaId,
        dataReserva
      );
      if (!atualizarReserva) {
        setErrorMessage("Não foi possível confirmar Reserva. Tente novamente!");
      } else {
        // Caso contrário, pode ser sucesso, se o retorno for esperado
        setSuccessMessage("Reserva confirmada com sucesso.");
      }
    } catch (error) {
      // Captura erros inesperados
      setErrorMessage("Erro ao atualizar a reserva. Tente novamente!");
    } finally {
      setIsLoading(false); // Garantir que o loading seja removido ao final
    }
  };

  return { atualizar, isLoading, warning, errorMessage, successMessage };
};
